import react, { useEffect, useState } from 'react';
import { Button, Divider, Grid, IconButton, Typography } from '@mui/material';
import MuiIcon from '../../../../../shared/styles/mui/helpers/mui-icon.helper';
import WizardStepperComponent from './components/wizard-stepper/wizard-stepper.component';
import { useWizardStepperContext } from '../../contexts/useWizardStepper.context';
import useWizardReportDataContext from '../../contexts/useWizardReportData.context';

interface IProps {
    onClose: (reloadAll: boolean) => void;
}
/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export default function WizardTitleBarComponent({ onClose }: IProps) {

    const { isNewReport } = useWizardStepperContext();
    const { clearReportData, resetReportData } = useWizardReportDataContext();


    return (
        <Grid container direction='column'>

            {/* header */}
            <Grid container direction='row' alignItems='center' sx={{ px: 2, pt: 1 }}>

                {/* title */}
                <Grid item xs>
                    {`${isNewReport ? 'Create' : 'Edit'} - Report`}
                </Grid>

                {/* Clear button */}
                {/* <Grid item xs='auto' container sx={{ mr: 2 }}>
                    <Button variant="text" size='small' color='warning' onClick={clearReportData} startIcon={MuiIcon.CLEAR_ALL()}>
                        Clear
                    </Button>
                </Grid> */}

                {/* Reset button */}
                <Grid item xs='auto' container sx={{ mr: 2 }}>
                    <Button variant="text" size='small' color='warning' onClick={resetReportData} startIcon={MuiIcon.RELOAD()}>
                        Reset
                    </Button>
                </Grid>

                {/* close button */}
                <Grid item xs='auto' container>
                    <Button variant="text" size='small' color='error' onClick={() => onClose(false)} startIcon={MuiIcon.CLOSE()}>
                        Close
                    </Button>
                </Grid>

            </Grid>


            {/* stepper */}
            <WizardStepperComponent />

        </Grid>
    )
}